import { render } from "./CustomerAddress.vue.ts?vue&type=template&id=49587b86&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomerAddress.vue?vue&type=template&id=49587b86&scoped=true&ts=true"
import script from "./CustomerAddress.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomerAddress.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerAddress.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomerAddress.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerAddress.vue.scss?vue&type=style&index=0&id=49587b86&lang=scss&scoped=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomerAddress.vue?vue&type=style&index=0&id=49587b86&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49587b86"],['__file',"src/apps/merchant3/shared-components/common/CustomerAddress.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "49587b86"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('49587b86', __exports__)) {
    api.reload('49587b86', __exports__)
  }
  
  module.hot.accept("./CustomerAddress.vue.ts?vue&type=template&id=49587b86&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomerAddress.vue?vue&type=template&id=49587b86&scoped=true&ts=true", () => {
    api.rerender('49587b86', render)
  })

}


export default __exports__